<template>
  <div class="project-type-selector">
    <!-- 标题区域 -->
    <div class="selector-header">
      <h2 class="title">{{ title }}</h2>
      
      <!-- 顶部操作链接 -->
      <div class="operation-links">
        <a href="javascript:void(0)" @click="handleOperation('json')" class="link-item">
          <i class="el-icon-upload2"></i> 导入Json文件
        </a>
        <a href="javascript:void(0)" @click="handleOperation('excel')" class="link-item">
          <i class="el-icon-document"></i> 导入Excel
        </a>
        <a href="javascript:void(0)" @click="handleOperation('template')" class="link-item">
          <i class="el-icon-box"></i> 从模板中心创建
        </a>
      </div>
    </div>

    <!-- 项目类型卡片区域【核心：平铺布局】 -->
    <div class="card-container">
      <div 
        v-for="(item, index) in projectTypes" 
        :key="index" 
        class="project-card"
        @click="handleSelect(item.type)"
      >
        <!-- 卡片图标（带颜色背景） -->
        <div class="card-icon" :style="{ backgroundColor: item.color }">
          <!-- 支持 SVG Symbol 图标或 Element 图标 -->
          <svg v-if="item.svgIcon" class="svg-icon" aria-hidden="true">
            <use :xlink:href="'#' + item.svgIcon"></use>
          </svg>
          <i v-else :class="item.iconClass"></i>
        </div>
        
        <!-- 卡片内容 -->
        <div class="card-content">
          <h3 class="card-title">{{ item.title }}</h3>
          <p class="card-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectTypeSelector',
  props: {
    // 可通过props自定义标题
    title: {
      type: String,
      default: '请选择您想要创建的项目类型'
    }
  },
  data() {
    return {
      // 项目类型数据（保持不变）
      projectTypes: [
        {
          type: 1,
          title: '问卷调查',
          desc: '创建调查问卷，市场调查，消费者满意度调查',
          color: '#409eff',
          iconClass: 'el-icon-edit-outline'
        },
        // 暂时隐藏收集表单
        // {
        //   type: 2,
        //   title: '收集表单',
        //   desc: '创建活动报名，预约报名，扫码核销，商品收款',
        //   color: '#722ed1',
        //   iconClass: 'el-icon-document-copy'
        // },
        {
          type: 3,
          title: '考试测评',
          desc: '创建考试题型，设置答案、分数提交后进行评分',
          color: '#00b42a',
          svgIcon: 'icon-kaoshi'
        }
        // 暂时隐藏360评估
        // {
        //   type: 4,
        //   title: '360评估',
        //   desc: '可用于组织内人才盘点，民主评议，绩效评估',
        //   color: '#14c9c9',
        //   svgIcon: 'icon-pingguchaxun'
        // }

      ]
    }
  },
  methods: {
    // 处理项目类型选择
    handleSelect(type) {
      const selectedItem = this.projectTypes.find(item => item.type === type);
      this.$emit('select', { type, ...selectedItem });
    },
    // 处理顶部操作链接点击
    handleOperation(type) {
      this.$emit('operation', type);
    }
  }
};
</script>

<style scoped>
.project-type-selector {
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
 /* box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);*/
  max-width: 1200px;
  margin: 0 auto;
}

/* 头部样式（保持不变） */
.selector-header {
  margin-bottom: 30px;
}
.title {
  font-size: 18px;
  color: #303133;
  margin: 0 0 16px 0;
  font-weight: 500;
}
.operation-links {
  display: flex;
  gap: 24px;
  flex-wrap: wrap; /* 操作链接也支持换行 */
}
.link-item {
  color: #409eff;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s;
}
.link-item:hover {
  color: #66b1ff;
}
.link-item i {
  font-size: 16px;
}

/* 卡片容器【核心修改：平铺网格布局】 */
.card-container {
  /* Grid布局：自动填充列数，最小宽度240px，最大宽度1fr */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px; /* 卡片之间的间距（行+列） */
  justify-items: stretch; /* 卡片拉伸填满网格列 */
}

/* 卡片样式（适配网格布局） */
.project-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 20px;
  background: #f2f3f8;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  /* 移除固定宽度，由网格布局自动分配 */
  height: 100%; /* 让同列卡片高度一致 */
  box-sizing: border-box;
}
.project-card:hover {
  border-color: #409eff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

/* 卡片图标（保持不变） */
.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.card-icon i {
  font-size: 24px;
  color: #fff;
}
.card-icon .svg-icon {
  width: 24px;
  height: 24px;
  fill: #fff;
}

/* 卡片内容（保持不变） */
.card-content {
  flex: 1;
}
.card-title {
  font-size: 16px;
  color: #303133;
  margin: 0 0 8px 0;
  font-weight: 500;
}
.card-desc {
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 响应式优化（可选：极小屏微调） */
@media (max-width: 375px) {
  .card-container {
    grid-template-columns: 1fr; /* 超小屏（手机SE）强制单列，避免卡片过窄 */
  }
  .project-card {
    padding: 16px;
  }
}
</style>